var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{staticClass:"d-flex justify-center text-h4",attrs:{"absolute":"","color":"red darken-4","dark":""}},[_vm._v(" Peerless Dad 180 ")]),_c('v-main',[_c('Story')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }